import React from 'react';
import Slider from 'react-slick';
import Lottie from 'lottie-react';
import Fan from '../Animation/fan.json';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    //name: 'Amit Sharma',
    title: "Ramesh Verma, Delhi",
    message: 'My AC wasn’t cooling at all during peak summer. They fixed the gas leak and now it works perfectly. Service was quick and clean.',
    //image: 'https://tse3.mm.bing.net/th?id=OIP.tTRHwzEHbc320XkOY-F1MQHaK3&pid=Api&P=0&h=180',
  },
  {
   // name: 'Sneha Patel',
    title: "Pooja Shah, Faridabad",
   // position: 'Customer Success Manager',
    message: 'Water was leaking from the indoor unit. The technician arrived on time and fixed the drainage problem in one visit. Very satisfied!',
   // image: 'https://tse2.mm.bing.net/th?id=OIP.0SHcMG-S2nNNUCieItMekAHaHo&pid=Api&P=0&h=180',
  },
  {
    //name: 'Rahul Verma',
    title: "Ankit Mehta, Faridabad",
    //position: 'Project Manager',
    message: 'There was a strange noise from the outdoor unit. They checked the fan motor and replaced it. Smooth experience and reasonable charges."',
   // image: 'https://tse3.mm.bing.net/th?id=OIP.q2B5zAygA0uBkG7qK2yLXwAAAA&pid=Api&P=0&h=180',
  },
  {
    //name: 'Neha Singh',
    title: "Saurabh Patil, Vaishali",
   // position: 'Quality Assurance Specialist',
    message: 'Cooling had dropped suddenly. Turned out to be low gas. They refilled it and also serviced the unit. Cooling is back to normal.',
   // image: 'https://tse3.mm.bing.net/th?id=OIP.mZ0_P3iZG38Cm7q6lRElGAHaEU&pid=Api&P=0&h=180',
  },
  {
    //name: 'Arjun Nair',
    title: "Ravi Agarwal, Indirapuram",
   // position: 'Technical Lead',
    message: 'AC was tripping the MCB again and again. They found a wiring issue and fixed it safely. Very professional and explained everything',
   // image: 'https://tse2.mm.bing.net/th?id=OIP.-lH1ETvAV04SfpktJfJVxwHaHa&pid=Api&P=0&h=180',
  },
];



const settings = {
  infinite: true,
  autoplay: true,
  autoplaySpeed: 6000,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  centerMode: true,
  centerPadding: '0px',
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2, centerMode: false }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1, centerMode: false }
    }
  ]
};

const Testimonial = () => {
  return (
    <div style={{
      backgroundImage: `url("/testimonial_bg_2.jpg")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}>
      <div className='w-full h-[600px] max-w-6xl mx-auto px-4'>
        <div className='pt-8'>
          <div className='flex items-center gap-2'>
            <Lottie className='w-6' animationData={Fan} />
            <h1 className='sm:text-2xl text-xl text-orange-500 font-bold uppercase'>
              Testimonials
            </h1>
          </div>
          <p className='sm:text-3xl text-2xl sm mt-4 font-bold text-[#0F1B4C]'>
            What Clients Say <br /> About Us
          </p>
        </div>

        <div className='mt-12'>
          <Slider {...settings} className=''>
            {testimonials.map((item, index) => (
              <div key={index}>
                <div className='px-4 relative group pt-8'>
                  <div className='bg-white text-center p-6 pt-16 relative hover:shadow-lg transition-shadow duration-300'>
                    {/* Profile image with conditional orange border for center slide and hover effect */}
                   {/* <div className='absolute -top-6 left-1/2 -translate-x-1/2'>
                      <div className={`
                        w-16 h-16 rounded-full overflow-hidden border-4 border-white shadow-md
                        group-[.slick-center]:border-orange-500
                        group-hover:border-orange-500
                        transition-colors duration-300
                      `}>
                        <img
                          src={item.image}
                          alt={item.name}
                          className='w-full h-full object-cover'
                        />
                      </div>
                    </div> */}
                    
                    <p className='font-semibold text-lg mb-1'>{item.title}</p>
                    <div className='text-orange-500 mb-2'>
                      {'★'.repeat(5)}
                    </div>
                    <p className='text-gray-600 text-sm mb-4'>{item.message}</p>
                    {/* <h3 className='font-bold text-[#0F1B4C]'>{item.name}</h3> */}
                    <p className='text-gray-500 text-sm'>{item.position}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;